import {getReportFile} from './reportFileQueries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {generateClient} from "aws-amplify/api";

export type ReportFile = {
    id: string,
    created?: number,
    filename?: string,
    purpose?: string,
    size?: number,
    type?: string,
    url?: string,
}

export type GetReportFile = {
    getReportFile: ReportFile
}

const client = generateClient();

export const fetchReportFile = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetReportFile>>({
                                                                           query: getReportFile,
                                                                           variables: {id: id},
                                                                       });
    return response.data?.getReportFile;
};
